export const login = {
    label: "Log In",
    href: "#",
    target: "internal",
};

export const more = {
    label: "More",
    href: "#",
    target: "internal",
};
